import { Requests } from '@/services/request.service'
import store from '@/store'
const requests = new Requests()

const state = {
  userData: null,
  bankData: null,
  identifier: null
}

const actions = {
  getUserData ({ commit }, identifier) {
    var id = identifier.length === 15 ? identifier.slice(0, -1) : identifier
    return new Promise((resolve, reject) => {
      requests.getUserData(id).then(data => {
        commit('saveIdentifier', data.userId)
        commit('saveUserData', data)
        resolve()
      }).catch((err) => reject(err))
    })
  },
  requestRefund ({ state }) {
    return new Promise((resolve, reject) => {
      var bankAccountType = store.state.configuration.configuration.bankAccountType
      requests.requestRefund(state.identifier, state.bankData, bankAccountType).then(() => {
        resolve()
      }).catch(() => {})
    })
  },
  resetData ({ state, dispatch }) {
    state.identifier = null
    state.totalRefund = null
    state.userData = null
    dispatch('getConfiguration')
  }
}

const mutations = {
  saveUserData (state, data) {
    state.userData = data
  },
  saveBankData (state, data) {
    state.bankData = data
  },
  saveIdentifier (state, identifier) {
    state.identifier = identifier
  }
}

export default {
  state,
  actions,
  mutations
}
